import { render, staticRenderFns } from "./dingdan-add.vue?vue&type=template&id=bbe8662c&scoped=true&"
import script from "./dingdan-add.vue?vue&type=script&lang=js&"
export * from "./dingdan-add.vue?vue&type=script&lang=js&"
import style0 from "./dingdan-add.vue?vue&type=style&index=0&id=bbe8662c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbe8662c",
  null
  
)

export default component.exports